module.exports = __webpack_public_path__ + "img/zhibo.a091dbd7.png";